import { Component, DestroyRef, inject} from '@angular/core';
import { UserDTO } from '../../../models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';
import { Subject, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
@Component({
    selector: 'app-create-customer',
    templateUrl: './create-customer.component.html',
    styleUrls: ['./create-customer.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class CreateCustomerComponent {

  
  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]), 
  });

  get emailModel() {
    return this.form.get('email');
  }

  information: string = 'Create Customer';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  mainContact?: string = undefined;
  additionalContactNumber?: string = undefined;
  email: string = '';
  fieldsCompleted: boolean = false;
  CustomerMessageError: string = '';
  seniorityDate?: Date = undefined;
  today: string = '';
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  validMail: boolean = false;

  alert: Alert = {} as Alert;
  customer: UserDTO = {} as UserDTO;

  constructor(
    private customerService: CustomerService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}
  ngOnInit() {
    const destroyed = new Subject();
    this.permissionsService.validateAccessLevels(MODULE_ID.Customers);
    const now = new Date();
    this.today = now.toISOString().split('T')[0]; // Formato 'YYYY-MM-DD'
      this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.CustomerMessageError = 'Unexpected error. Please try again later.';
        this.clearFields();
      }
    );
  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    //Se redirecciona a la ruta /home
    window.location.href = '/home';
  }

  createCustomer() {
    this.customer.userAddressLine1 = this.address;
    this.customer.userPhone = this.contactNumber;
    this.customer.userNames = this.customerName;
    this.customer.userMail = this.email;
    this.customer.userState = this.stateSelected;
    this.customer.userPostalCode = this.zipCode;
    this.customer.userCity = this.city;
    this.customer.seniorityDate = this.seniorityDate !== undefined ? new Date(this.seniorityDate) : undefined;
    this.customer.additionalContactNumber = this.additionalContactNumber;
    this.customer.mainContact = this.mainContact;

    this.customerService.saveCustomer(this.customer).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.CustomerMessageError = 'Unexpected error. Please try again later.';
        this.clearFields();
      }
    );
  }

  checkFields() {
    this.checkEmailValidity();
    if (this.customerName && this.contactNumber && this.email && this.validMail) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
    // console.log("this.customerName");
    // console.log(this.customerName);
    // console.log("this.contactNumber");
    // console.log(this.contactNumber);
    // console.log("this.email");
    // console.log(this.email);
    // console.log("this.validMail");
    // console.log(this.validMail);
    // console.log("this.fieldsCompleted");
    // console.log(this.fieldsCompleted);
  }

  handleSaveError(StatusCode: number) {
    this.CustomerMessageError = 'Unexpected error';
    this.clearFields();
  }

  async handleSaveSuccess(customer: UserDTO) {
    //console.log(customer.userId);
    if (customer.userId === 0) {
      this.alert = {
        alertMessage: 'This user already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };

      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'Customer saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }
  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    this.address = '';
    this.contactNumber = undefined;
    this.customerName = '';
    this.email = '';
    this.stateSelected = '';
    this.zipCode = undefined;
    this.city = '';
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
    //console.log(this.validMail);
  }
}
